/**
 * Global middleware for SSR fallback handling
 * Gracefully falls back to SPA mode when SSR fails
 * TEMPORARILY DISABLED for debugging
 */

export default defineNuxtRouteMiddleware((to) => {
  // Temporarily disable to reduce log noise and focus on main issue
  return
  
  // Only run on server side
  if (!process.server) return

  try {
    // Check if this is a route that should have SSR
    const ssrRoutes = [
      '/',
      '/specialty',
      '/doctor',
      '/search',
      '/health-insurance',
      '/contact',
      '/policy'
    ]

    const shouldUseSSR = ssrRoutes.some(route => 
      to.path.startsWith(route) && 
      !to.path.startsWith('/provider') && 
      !to.path.startsWith('/admin')
    )

    if (shouldUseSSR) {
      console.debug('[SSR Fallback] Route should use SSR:', to.path)
    }

  } catch (error) {
    // If anything fails, log but don't block
    console.warn('[SSR Fallback] Middleware warning:', error)
  }
})
